export const BASE_PATH_DEV_MERCHANT = 'https://api-merchant.bharatpe.in/merchant/';
export const BASE_PATH_PROD_MERCHANT = 'https://api-merchant.bharatpe.in/merchant/';
export const BASE_PATH_UAT_MERCHANT = 'https://merchant-uat.bharatpe.in/merchant/';
export const BASE_PATH_QA_MERCHANT = 'https://api-merchant.bharatpe.co.in/merchant/';
export const BASE_PATH_STAGE_MERCHANT = 'https://api-merchant.bharatpe.io/merchant/';

const getPgEndpoint = (): string => {
	const locationUrl = window.location.href;
	if (locationUrl.includes('bp-pg.bharatpe.io')) return 'https://payment-gateway.bharatpe.io';
	if (locationUrl.includes('bp-pg-uat.bharatpe.in')) return 'https://payment-gateway-pp.bharatpe.in';
	if (locationUrl.includes('bp-pg-uat1.bharatpe.in')) return 'https://payment-gateway.bharatpe.co.in';
	if (locationUrl.includes('localhost')) return 'https://payment-gateway-pp.bharatpe.in';
	return 'https://payment-gateway.bharatpe.in';
};

const getPgUpiEndpoint = (): string => {
	const locationUrl = window.location.href;
	if (locationUrl.includes('bp-pg.bharatpe.io')) return 'https://pg-upi-service-stg.bharatpe.io';
	if (locationUrl.includes('bp-pg-uat.bharatpe.in')) return 'https://upi-mrt-sdk.bharatpe.in';
	if (locationUrl.includes('bp-pg-uat1.bharatpe.in')) return 'https://pg-upi-service-uat.bharatpe.in';
	if (locationUrl.includes('localhost')) return 'https://upi-mrt-sdk.bharatpe.in';
	return 'https://upi-mrt-sdk.bharatpe.in';
};

const base_url = getPgEndpoint();
const pg_upi_base_url = getPgUpiEndpoint();

export const API_URL = {
	merchantInfo: 'v3/getmerchantinfo',
	payment_mode: `${base_url}/v1/transaction/`,
	payment_status: `${base_url}/v1/transaction/`,
	verify_otp: `${base_url}/v1/transaction/generate-otp`,
	resend_otp: `${base_url}/v1/transaction/resend-otp`,
	getPaymentModesV2: `${base_url}/v2/transaction/`,
	getPaymentModesV3: `${base_url}/v3/transaction/`,
	updateCheckoutType: `${base_url}/v2/transaction/update-transaction/`,
	getMandate: `${base_url}/v2/mandate`,
	get_cashback: 'https://api-postpe.bharatpe.in/postpe/v1/cashback',
	apply_cashback: 'https://api-postpe.bharatpe.in/postpe/v1/cashback/apply',
	toggle_postpe_cashback: 'https://api-postpe.bharatpe.in/postpe/v1/cashback',
	get_card_info: 'https://payment-gateway.bharatpe.in/v1/shared/card-data',
	settlement_account: `${base_url}/v2/mandate/`,
	customer_settlement_account: `${base_url}/v2/mandate/get-settlement-account`,
	all_transactions: `${pg_upi_base_url}/upi/transactions/v1`,
	udir_reason_codes: `${pg_upi_base_url}/upi/udir/v1/reason-codes`,
	fetch_comaplaint: `${pg_upi_base_url}/upi/udir/v1/complaints/`,
	all_fetch_comaplaint: `${pg_upi_base_url}/upi/udir/v1/complaints`,
	register_complaint: `${pg_upi_base_url}/upi/udir/v1/complaints`,
	transaction_details: `${pg_upi_base_url}/upi/transactions/v1`,
	all_mandates: `${pg_upi_base_url}/upi/mandates/v1`,
	mandate_details: `${pg_upi_base_url}/upi/mandates/v1`,
	user_upi_details: `${pg_upi_base_url}/upi/account/v1/user`,
	upi_settlement_account: `${pg_upi_base_url}/upi/banks/v1/get-settlement-account`,
	validate_settlement_account: `${pg_upi_base_url}/upi/banks/v1/validate-settlement-account`,
	create_user: `${pg_upi_base_url}/upi/account/v1/create-user`,
	pending_collect_request: `${pg_upi_base_url}/upi/transactions/v1/pending-collect-requests`,
};

const setMerchantBaseUrlAccordingToEnv = () => {
	if (window.location.host.includes('bharatpe.io')) {
		return BASE_PATH_STAGE_MERCHANT;
	} else if (window.location.host.includes('bharatpe.co')) {
		return BASE_PATH_QA_MERCHANT;
	} else if (window.location.href.includes('bp-pg-uat.bharatpe.in')) {
		return BASE_PATH_UAT_MERCHANT;
	} else if (window.location.href.includes('bp-pg-uat1.bharatpe.in')) {
		return BASE_PATH_QA_MERCHANT;
	} else if (window.location.host.includes('localhost')) {
		return BASE_PATH_UAT_MERCHANT;
		return BASE_PATH_QA_MERCHANT;
	}
	return BASE_PATH_PROD_MERCHANT;
};
export const BASE_PATH_MERCHANT = setMerchantBaseUrlAccordingToEnv();
